import React from "react";
import "./style.scss";

class ValidationError extends React.Component {
  render() {
    const { meta } = this.props;
    return meta.error && meta.dirty ? (
      <div className="validation-label__error">
        <i>{meta.error}</i>
      </div>
    ) : null;
  }
}

export default ValidationError;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Form/ValidationError.js